import { connect } from 'react-redux';
import PropertyAddress from './PropertyAddress';
import getRonaeleOrderDetailsUrl from '../helpers/getRonaeleOrderDetailsUrl';

const mapStateToProps = ({ estimateBuilder }) => {
  const { entities, uiState } = estimateBuilder;
  const { estimates } = entities;
  const { selectedEstimate } = uiState;

  const { siteId } = window.globalConfig;

  const estimate = estimates.byId[selectedEstimate];
  const {
    propertyAddress,
    isAutoReleaseDesign,
    orderNumber,
  } = estimate && estimate.attributes;

  const orderDetailsUrl = getRonaeleOrderDetailsUrl(siteId, orderNumber);

  return {
    propertyAddress: JSON.parse(propertyAddress),
    isAutoReleaseDesign: isAutoReleaseDesign === 'true',
    orderNumber,
    orderDetailsUrl,
  };
};

export default connect(mapStateToProps)(PropertyAddress);
